import { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, adminOnly = false }) {
    const { user } = useAuth();
    const location = useLocation();

    useEffect(() => {
        // Override existing robots meta to noindex for the entire admin section
        const meta = document.querySelector('meta[name="robots"]');
        const prev = meta ? meta.getAttribute("content") : null;
        if (meta) {
            meta.setAttribute("content", "noindex, nofollow, noarchive");
        } else {
            const m = document.createElement("meta");
            m.name = "robots";
            m.content = "noindex, nofollow, noarchive";
            m.setAttribute("data-admin-noindex", "true");
            document.head.appendChild(m);
        }
        return () => {
            const cur = document.querySelector('meta[name="robots"]');
            if (cur && cur.getAttribute("data-admin-noindex") === "true") {
                cur.remove();
            } else if (cur && prev !== null) {
                cur.setAttribute("content", prev);
            }
        };
    }, []);

    if (user === null) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7]">
                <div className="overline text-[#64748B]">Vérification…</div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/admin/login" state={{ from: location }} replace />;
    }

    if (adminOnly && user.role !== "admin") {
        return <Navigate to="/admin/login" replace />;
    }

    return children;
}
